import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Divider } from './components/Divider';
import { Footer } from './components/Footer';
import { useMetaPixel } from './components/MetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-sage/30 selection:text-charcoal" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />

        <div className="bg-white" data-id="element-3">
          <Divider data-id="element-4" />
        </div>

        <WhatYouGetSection data-id="element-5" />
        <HowItWorksSection data-id="element-6" />
        <FAQSection data-id="element-7" />
        <OfferSection data-id="element-8" />
      </main>

      <Footer data-id="element-9" />
    </div>;
}